import styled from 'styled-components'

export const FeedLabelStyled = styled.div`
  font-size: ${(props) =>
    props.theme.typography.pxToRem(props.theme.fontSizes.label)};

  padding-right: ${(props) => props.theme.typography.pxToRem(12)};
`
